import Dexie from 'dexie';

/** A journal is scoped to an account AND editor tab. It is never a cloud read cache. */
export function createDraftJournal({ userId, tabId, name = 'linework-unsaved-drafts-v1', indexedDB, IDBKeyRange }) {
  const db = new Dexie(name, indexedDB ? { indexedDB, IDBKeyRange } : undefined);
  db.version(1).stores({ drafts: 'key, userId' });
  let writes = Promise.resolve(), failure = null;
  function stage(doc, view, label, revision) {
    const token = crypto.randomUUID();
    const entry = structuredClone({ key: `${userId}:${tabId}:${doc.id}`, userId, tabId, doc, view, label, revision, token, updatedAt: Date.now() });
    writes = writes.then(() => db.drafts.put(entry)).then(() => { failure = null; }, error => { failure = error; });
    return token;
  }
  async function flush() { await writes; if (failure) throw new Error('The browser could not retain your recovery draft. Export JSON before closing this tab.', { cause: failure }); }
  async function remove(entry) {
    await db.transaction('rw', db.drafts, async () => {
      const current = await db.drafts.get(entry.key);
      if (current?.userId === userId && current.token === entry.token) await db.drafts.delete(entry.key);
    });
  }
  return {
    stage, flush,
    async ack(id, token) { await writes; await remove({ key: `${userId}:${tabId}:${id}`, token }); },
    remove,
    async discard(id) {
      await writes;
      const entry = await db.drafts.get(`${userId}:${tabId}:${id}`);
      if (entry) await remove(entry);
      failure = null;
    },
    async list() { await writes; return db.drafts.where('userId').equals(userId).toArray(); },
    close: () => db.close(),
  };
}
